var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeLineGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 219,
    viewBox: "0 0 345 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25293 218.425V9.42505",
    stroke: "url(#paint0_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2529 218.425V9.42505",
    stroke: "url(#paint1_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2529 218.425V9.42505",
    stroke: "url(#paint2_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2529 218.425V9.42505",
    stroke: "url(#paint3_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7529 218.425V9.42505",
    stroke: "url(#paint4_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2529 218.425V9.42505",
    stroke: "url(#paint5_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2529 218.425V9.42505",
    stroke: "url(#paint6_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.253 218.425V9.42505",
    stroke: "url(#paint7_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.253 218.425V9.42505",
    stroke: "url(#paint8_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 218.425V9.42505",
    stroke: "url(#paint9_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.253 218.425V9.42505",
    stroke: "url(#paint10_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 218.425V9.42505",
    stroke: "url(#paint11_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.253 218.425V9.42505",
    stroke: "url(#paint12_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.753 218.425V9.42505",
    stroke: "url(#paint13_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.753 218.425V9.42505",
    stroke: "url(#paint14_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M222.753 218.425V9.42505",
    stroke: "url(#paint15_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.253 218.425V9.42505",
    stroke: "url(#paint16_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.253 218.425V9.42505",
    stroke: "url(#paint17_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M266.253 218.425V9.42505",
    stroke: "url(#paint18_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M281.253 218.425V9.42505",
    stroke: "url(#paint19_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M296.253 218.425V9.42505",
    stroke: "url(#paint20_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M311.253 218.425V9.42505",
    stroke: "url(#paint21_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M326.253 218.425V9.42505",
    stroke: "url(#paint22_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M341.253 218.425V9.42505",
    stroke: "url(#paint23_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M341 217.43V9.42505",
    stroke: "url(#paint24_linear_605_777)",
    strokeOpacity: 0.4,
    strokeLinecap: "square",
    strokeDasharray: 6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26693 5.86621V13H6.09017V7.2627L4.347 7.85352V6.88184L7.12533 5.86621H7.26693ZM12.7243 12.209C13.626 12.209 14.3324 12.126 14.8434 11.96L13.0319 7.00879H14.0231L15.6247 11.5791C15.9307 11.361 16.1764 11.0697 16.362 10.7051C16.5508 10.3372 16.6875 9.85547 16.7721 9.25977C16.86 8.66406 16.904 7.91374 16.904 7.00879H17.8464C17.8464 8.5127 17.6868 9.69108 17.3678 10.5439C17.153 11.1104 16.8519 11.5791 16.4645 11.9502C16.0771 12.318 15.5775 12.6012 14.9655 12.7998C14.3568 12.9951 13.6097 13.1156 12.7243 13.1611V12.209ZM20.5091 7.00879V13H19.6107V7.00879H20.5091ZM27.4053 12.1699V13H22.1758V12.1699H25.8574V9.47949C25.8574 8.88053 25.7354 8.45736 25.4912 8.20996C25.2503 7.96257 24.832 7.83887 24.2363 7.83887H22.4053V7.00879H24.2461C25.1445 7.00879 25.7874 7.20085 26.1748 7.58496C26.5622 7.96908 26.7559 8.60384 26.7559 9.48926V12.1699H27.4053ZM33.5202 12.3945C33.2956 12.5443 33.0156 12.6663 32.6803 12.7607C32.3483 12.8551 31.9316 12.9251 31.4303 12.9707C30.929 13.0163 30.3089 13.0423 29.57 13.0488L28.4274 7.00879H29.36L29.9606 10.0898L30.3171 10.0215C30.5124 9.97591 30.6735 9.91732 30.8005 9.8457C30.9274 9.77083 31.0283 9.66667 31.1032 9.5332C31.165 9.42904 31.2122 9.30046 31.2448 9.14746C31.2773 8.99447 31.3018 8.81217 31.318 8.60059L31.4401 7.00879H32.3678L32.2165 8.61035C32.1937 8.88053 32.166 9.11491 32.1335 9.31348C32.1009 9.50879 32.0619 9.66667 32.0163 9.78711C31.9349 10.0312 31.8128 10.2201 31.6501 10.3535C31.4873 10.4837 31.2171 10.5993 30.8395 10.7002L30.1071 10.8711L30.3464 12.1309H30.4635C31.1178 12.1309 31.6419 12.0934 32.0358 12.0186C32.4297 11.9404 32.7406 11.82 32.9684 11.6572C33.1214 11.5465 33.25 11.4098 33.3542 11.2471C33.4583 11.0843 33.5462 10.8695 33.6178 10.6025C33.6895 10.3356 33.7497 9.99219 33.7985 9.57227L34.1061 7.00879H35.0485L34.736 9.53809C34.6709 10.1045 34.5863 10.5716 34.4821 10.9395C34.3779 11.304 34.2477 11.6003 34.0915 11.8281C33.9385 12.0527 33.748 12.2415 33.5202 12.3945Z",
    fill: "#B7B7B7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.951 10.4658V11.4033H104.825L104.785 10.6953L107.852 5.89062H108.794L107.774 7.63867L106.011 10.4658H109.951ZM109.063 5.89062V13H107.886V5.89062H109.063ZM113.724 12.209C114.626 12.209 115.332 12.126 115.843 11.96L114.032 7.00879H115.023L116.625 11.5791C116.931 11.361 117.176 11.0697 117.362 10.7051C117.551 10.3372 117.687 9.85547 117.772 9.25977C117.86 8.66406 117.904 7.91374 117.904 7.00879H118.846C118.846 8.5127 118.687 9.69108 118.368 10.5439C118.153 11.1104 117.852 11.5791 117.465 11.9502C117.077 12.318 116.577 12.6012 115.965 12.7998C115.357 12.9951 114.61 13.1156 113.724 13.1611V12.209ZM121.509 7.00879V13H120.611V7.00879H121.509ZM128.405 12.1699V13H123.176V12.1699H126.857V9.47949C126.857 8.88053 126.735 8.45736 126.491 8.20996C126.25 7.96257 125.832 7.83887 125.236 7.83887H123.405V7.00879H125.246C126.145 7.00879 126.787 7.20085 127.175 7.58496C127.562 7.96908 127.756 8.60384 127.756 9.48926V12.1699H128.405ZM134.52 12.3945C134.296 12.5443 134.016 12.6663 133.68 12.7607C133.348 12.8551 132.932 12.9251 132.43 12.9707C131.929 13.0163 131.309 13.0423 130.57 13.0488L129.427 7.00879H130.36L130.961 10.0898L131.317 10.0215C131.512 9.97591 131.674 9.91732 131.8 9.8457C131.927 9.77083 132.028 9.66667 132.103 9.5332C132.165 9.42904 132.212 9.30046 132.245 9.14746C132.277 8.99447 132.302 8.81217 132.318 8.60059L132.44 7.00879H133.368L133.216 8.61035C133.194 8.88053 133.166 9.11491 133.133 9.31348C133.101 9.50879 133.062 9.66667 133.016 9.78711C132.935 10.0312 132.813 10.2201 132.65 10.3535C132.487 10.4837 132.217 10.5993 131.84 10.7002L131.107 10.8711L131.346 12.1309H131.464C132.118 12.1309 132.642 12.0934 133.036 12.0186C133.43 11.9404 133.741 11.82 133.968 11.6572C134.121 11.5465 134.25 11.4098 134.354 11.2471C134.458 11.0843 134.546 10.8695 134.618 10.6025C134.689 10.3356 134.75 9.99219 134.799 9.57227L135.106 7.00879H136.049L135.736 9.53809C135.671 10.1045 135.586 10.5716 135.482 10.9395C135.378 11.304 135.248 11.6003 135.091 11.8281C134.938 12.0527 134.748 12.2415 134.52 12.3945Z",
    fill: "#B7B7B7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.702 11.0615C210.702 11.5042 210.6 11.877 210.395 12.1797C210.19 12.4824 209.91 12.7119 209.555 12.8682C209.203 13.0212 208.806 13.0977 208.364 13.0977C207.921 13.0977 207.522 13.0212 207.167 12.8682C206.812 12.7119 206.533 12.4824 206.327 12.1797C206.122 11.877 206.02 11.5042 206.02 11.0615C206.02 10.7686 206.077 10.5033 206.191 10.2656C206.305 10.0247 206.466 9.81803 206.674 9.64551C206.886 9.46973 207.133 9.33464 207.416 9.24023C207.703 9.14583 208.015 9.09863 208.354 9.09863C208.803 9.09863 209.205 9.18164 209.56 9.34766C209.915 9.51367 210.193 9.74316 210.395 10.0361C210.6 10.3291 210.702 10.6709 210.702 11.0615ZM209.521 11.0029C209.521 10.7653 209.472 10.557 209.374 10.3779C209.277 10.1989 209.14 10.0605 208.964 9.96289C208.788 9.86523 208.585 9.81641 208.354 9.81641C208.119 9.81641 207.916 9.86523 207.743 9.96289C207.571 10.0605 207.436 10.1989 207.338 10.3779C207.244 10.557 207.197 10.7653 207.197 11.0029C207.197 11.2438 207.244 11.4521 207.338 11.6279C207.433 11.8005 207.568 11.9323 207.743 12.0234C207.919 12.1146 208.126 12.1602 208.364 12.1602C208.601 12.1602 208.806 12.1146 208.979 12.0234C209.151 11.9323 209.285 11.8005 209.379 11.6279C209.474 11.4521 209.521 11.2438 209.521 11.0029ZM210.541 7.76074C210.541 8.11556 210.447 8.43132 210.258 8.70801C210.073 8.9847 209.815 9.2028 209.487 9.3623C209.158 9.51855 208.784 9.59668 208.364 9.59668C207.94 9.59668 207.563 9.51855 207.231 9.3623C206.902 9.2028 206.643 8.9847 206.454 8.70801C206.269 8.43132 206.176 8.11556 206.176 7.76074C206.176 7.33757 206.269 6.98112 206.454 6.69141C206.643 6.39844 206.902 6.17546 207.231 6.02246C207.56 5.86947 207.936 5.79297 208.359 5.79297C208.782 5.79297 209.158 5.86947 209.487 6.02246C209.815 6.17546 210.073 6.39844 210.258 6.69141C210.447 6.98112 210.541 7.33757 210.541 7.76074ZM209.365 7.7998C209.365 7.58822 209.322 7.40267 209.238 7.24316C209.156 7.0804 209.041 6.95345 208.891 6.8623C208.741 6.77116 208.564 6.72559 208.359 6.72559C208.154 6.72559 207.976 6.76953 207.826 6.85742C207.677 6.94531 207.561 7.06901 207.48 7.22852C207.398 7.38802 207.358 7.57845 207.358 7.7998C207.358 8.0179 207.398 8.20833 207.48 8.37109C207.561 8.5306 207.677 8.65592 207.826 8.74707C207.979 8.83822 208.159 8.88379 208.364 8.88379C208.569 8.88379 208.746 8.83822 208.896 8.74707C209.046 8.65592 209.161 8.5306 209.243 8.37109C209.324 8.20833 209.365 8.0179 209.365 7.7998ZM214.724 12.209C215.626 12.209 216.332 12.126 216.843 11.96L215.032 7.00879H216.023L217.625 11.5791C217.931 11.361 218.176 11.0697 218.362 10.7051C218.551 10.3372 218.687 9.85547 218.772 9.25977C218.86 8.66406 218.904 7.91374 218.904 7.00879H219.846C219.846 8.5127 219.687 9.69108 219.368 10.5439C219.153 11.1104 218.852 11.5791 218.465 11.9502C218.077 12.318 217.577 12.6012 216.965 12.7998C216.357 12.9951 215.61 13.1156 214.724 13.1611V12.209ZM222.509 7.00879V13H221.611V7.00879H222.509ZM229.405 12.1699V13H224.176V12.1699H227.857V9.47949C227.857 8.88053 227.735 8.45736 227.491 8.20996C227.25 7.96257 226.832 7.83887 226.236 7.83887H224.405V7.00879H226.246C227.145 7.00879 227.787 7.20085 228.175 7.58496C228.562 7.96908 228.756 8.60384 228.756 9.48926V12.1699H229.405ZM235.52 12.3945C235.296 12.5443 235.016 12.6663 234.68 12.7607C234.348 12.8551 233.932 12.9251 233.43 12.9707C232.929 13.0163 232.309 13.0423 231.57 13.0488L230.427 7.00879H231.36L231.961 10.0898L232.317 10.0215C232.512 9.97591 232.674 9.91732 232.8 9.8457C232.927 9.77083 233.028 9.66667 233.103 9.5332C233.165 9.42904 233.212 9.30046 233.245 9.14746C233.277 8.99447 233.302 8.81217 233.318 8.60059L233.44 7.00879H234.368L234.216 8.61035C234.194 8.88053 234.166 9.11491 234.133 9.31348C234.101 9.50879 234.062 9.66667 234.016 9.78711C233.935 10.0312 233.813 10.2201 233.65 10.3535C233.487 10.4837 233.217 10.5993 232.84 10.7002L232.107 10.8711L232.346 12.1309H232.464C233.118 12.1309 233.642 12.0934 234.036 12.0186C234.43 11.9404 234.741 11.82 234.968 11.6572C235.121 11.5465 235.25 11.4098 235.354 11.2471C235.458 11.0843 235.546 10.8695 235.618 10.6025C235.689 10.3356 235.75 9.99219 235.799 9.57227L236.106 7.00879H237.049L236.736 9.53809C236.671 10.1045 236.586 10.5716 236.482 10.9395C236.378 11.304 236.248 11.6003 236.091 11.8281C235.938 12.0527 235.748 12.2415 235.52 12.3945Z",
    fill: "#B7B7B7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M308.717 5.86621V13H307.54V7.2627L305.797 7.85352V6.88184L308.575 5.86621H308.717ZM315.159 5.84668H315.305V6.80859H315.222C314.802 6.80859 314.439 6.8737 314.133 7.00391C313.831 7.13411 313.582 7.31315 313.386 7.54102C313.191 7.76888 313.045 8.03581 312.947 8.3418C312.853 8.64453 312.805 8.9668 312.805 9.30859V10.4268C312.805 10.71 312.836 10.9606 312.898 11.1787C312.96 11.3936 313.046 11.5742 313.157 11.7207C313.271 11.8639 313.401 11.973 313.548 12.0479C313.694 12.1227 313.852 12.1602 314.021 12.1602C314.197 12.1602 314.356 12.1243 314.5 12.0527C314.643 11.9779 314.765 11.8753 314.866 11.7451C314.967 11.6149 315.043 11.4603 315.095 11.2812C315.147 11.1022 315.174 10.9069 315.174 10.6953C315.174 10.4935 315.147 10.3047 315.095 10.1289C315.047 9.94987 314.973 9.79362 314.876 9.66016C314.778 9.52344 314.656 9.41764 314.509 9.34277C314.366 9.26465 314.2 9.22559 314.011 9.22559C313.777 9.22559 313.564 9.28092 313.372 9.3916C313.183 9.50228 313.03 9.64714 312.913 9.82617C312.799 10.002 312.737 10.1891 312.727 10.3877L312.278 10.2412C312.304 9.93848 312.371 9.66667 312.478 9.42578C312.589 9.1849 312.734 8.97982 312.913 8.81055C313.092 8.64128 313.299 8.5127 313.533 8.4248C313.771 8.33366 314.031 8.28809 314.314 8.28809C314.659 8.28809 314.959 8.35319 315.213 8.4834C315.466 8.61361 315.676 8.79102 315.842 9.01562C316.012 9.23698 316.137 9.49089 316.218 9.77734C316.303 10.0605 316.345 10.3568 316.345 10.666C316.345 11.0078 316.293 11.3268 316.189 11.623C316.085 11.916 315.932 12.1732 315.73 12.3945C315.532 12.6159 315.289 12.7884 315.003 12.9121C314.719 13.0358 314.397 13.0977 314.036 13.0977C313.655 13.0977 313.315 13.0244 313.015 12.8779C312.719 12.7314 312.467 12.5296 312.258 12.2725C312.053 12.0153 311.897 11.7191 311.79 11.3838C311.682 11.0485 311.629 10.6937 311.629 10.3193V9.83105C311.629 9.29069 311.697 8.78125 311.834 8.30273C311.97 7.82096 312.18 7.39616 312.464 7.02832C312.75 6.66048 313.116 6.3724 313.562 6.16406C314.008 5.95247 314.54 5.84668 315.159 5.84668ZM320.274 12.209C321.176 12.209 321.882 12.126 322.394 11.96L320.582 7.00879H321.573L323.175 11.5791C323.481 11.361 323.727 11.0697 323.912 10.7051C324.101 10.3372 324.238 9.85547 324.322 9.25977C324.41 8.66406 324.454 7.91374 324.454 7.00879H325.396C325.396 8.5127 325.237 9.69108 324.918 10.5439C324.703 11.1104 324.402 11.5791 324.015 11.9502C323.627 12.318 323.128 12.6012 322.516 12.7998C321.907 12.9951 321.16 13.1156 320.274 13.1611V12.209ZM328.059 7.00879V13H327.161V7.00879H328.059ZM334.955 12.1699V13H329.726V12.1699H333.408V9.47949C333.408 8.88053 333.285 8.45736 333.041 8.20996C332.8 7.96257 332.382 7.83887 331.786 7.83887H329.955V7.00879H331.796C332.695 7.00879 333.338 7.20085 333.725 7.58496C334.112 7.96908 334.306 8.60384 334.306 9.48926V12.1699H334.955ZM341.07 12.3945C340.846 12.5443 340.566 12.6663 340.23 12.7607C339.898 12.8551 339.482 12.9251 338.98 12.9707C338.479 13.0163 337.859 13.0423 337.12 13.0488L335.978 7.00879H336.91L337.511 10.0898L337.867 10.0215C338.062 9.97591 338.224 9.91732 338.351 9.8457C338.478 9.77083 338.578 9.66667 338.653 9.5332C338.715 9.42904 338.762 9.30046 338.795 9.14746C338.827 8.99447 338.852 8.81217 338.868 8.60059L338.99 7.00879H339.918L339.767 8.61035C339.744 8.88053 339.716 9.11491 339.684 9.31348C339.651 9.50879 339.612 9.66667 339.566 9.78711C339.485 10.0312 339.363 10.2201 339.2 10.3535C339.037 10.4837 338.767 10.5993 338.39 10.7002L337.657 10.8711L337.896 12.1309H338.014C338.668 12.1309 339.192 12.0934 339.586 12.0186C339.98 11.9404 340.291 11.82 340.519 11.6572C340.672 11.5465 340.8 11.4098 340.904 11.2471C341.008 11.0843 341.096 10.8695 341.168 10.6025C341.24 10.3356 341.3 9.99219 341.349 9.57227L341.656 7.00879H342.599L342.286 9.53809C342.221 10.1045 342.136 10.5716 342.032 10.9395C341.928 11.304 341.798 11.6003 341.642 11.8281C341.489 12.0527 341.298 12.2415 341.07 12.3945Z",
    fill: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_605_777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 32,
    width: 338,
    height: 187
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4 32.425H342V203.425C342 211.709 335.284 218.425 327 218.425H19C10.7157 218.425 4 211.709 4 203.425V32.425Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_605_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 180.425L48.6168 172.505C48.9084 172.454 49.2075 172.535 49.4335 172.727L69.7163 189.879C70.089 190.194 70.6349 190.194 71.0077 189.879L91.0604 172.921C91.4063 172.629 91.9058 172.605 92.2776 172.864L116.627 189.822C117.098 190.15 117.747 190.015 118.049 189.528L138.709 156.173C139.149 155.464 140.212 155.572 140.498 156.356L152.549 189.278C152.766 189.871 153.471 190.117 154.01 189.787L181.799 172.77C182.14 172.561 182.574 172.576 182.9 172.807L207.122 190.014C207.469 190.26 207.934 190.26 208.28 190.014L232.384 172.892C232.767 172.619 233.289 172.651 233.636 172.968L252.06 189.746C252.471 190.12 253.107 190.088 253.478 189.675L263.774 178.191C264.151 177.772 264.799 177.746 265.208 178.134L277.329 189.65C277.763 190.062 278.46 190.003 278.819 189.523L298.442 163.248C298.891 162.646 299.819 162.736 300.144 163.414L312.433 189.009C312.75 189.668 313.645 189.776 314.108 189.209L323.163 178.149C323.497 177.741 324.089 177.662 324.517 177.968L342 190.425",
    stroke: "#7B7A7A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 179.425C3.5 179.425 40 165.667 71.5 155.925C92.6866 153.567 114.5 136.449 154.5 127.925C194 116.154 189.5 115.046 240.356 98.768C294.5 84.1966 341.5 68.425 341.5 68.425L343.869 215.296C343.941 219.764 340.339 223.425 335.87 223.425H13.5584C9.31637 223.425 5.81187 220.114 5.57124 215.879L3.5 179.425Z",
    fill: "url(#paint25_linear_605_777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 178.313C4 178.313 308.87 75.726 341.5 67.925",
    stroke: "url(#paint26_linear_605_777)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_777",
    x1: 2.7572,
    y1: 9.42505,
    x2: 2.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_777",
    x1: 17.7572,
    y1: 9.42505,
    x2: 17.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_605_777",
    x1: 32.7572,
    y1: 9.42505,
    x2: 32.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_605_777",
    x1: 47.7572,
    y1: 9.42505,
    x2: 47.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_605_777",
    x1: 62.7558,
    y1: 9.42505,
    x2: 62.7558,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_605_777",
    x1: 76.7572,
    y1: 9.42505,
    x2: 76.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_605_777",
    x1: 91.7572,
    y1: 9.42505,
    x2: 91.7572,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_605_777",
    x1: 106.757,
    y1: 9.42505,
    x2: 106.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_605_777",
    x1: 121.757,
    y1: 9.42505,
    x2: 121.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_605_777",
    x1: 136.757,
    y1: 9.42505,
    x2: 136.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_605_777",
    x1: 151.757,
    y1: 9.42505,
    x2: 151.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_605_777",
    x1: 166.757,
    y1: 9.42505,
    x2: 166.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_605_777",
    x1: 181.757,
    y1: 9.42505,
    x2: 181.757,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_605_777",
    x1: 196.756,
    y1: 9.42505,
    x2: 196.756,
    y2: 217.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_605_777",
    x1: 209.312,
    y1: 9.42505,
    x2: 209.312,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_605_777",
    x1: 221.312,
    y1: 9.42505,
    x2: 221.312,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_605_777",
    x1: 234.756,
    y1: 9.42505,
    x2: 234.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_605_777",
    x1: 249.756,
    y1: 9.42505,
    x2: 249.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_605_777",
    x1: 264.756,
    y1: 9.42505,
    x2: 264.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_605_777",
    x1: 279.756,
    y1: 9.42505,
    x2: 279.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_605_777",
    x1: 294.756,
    y1: 9.42505,
    x2: 294.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_605_777",
    x1: 309.756,
    y1: 9.42505,
    x2: 309.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_605_777",
    x1: 324.756,
    y1: 9.42505,
    x2: 324.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_605_777",
    x1: 339.756,
    y1: 9.42505,
    x2: 339.756,
    y2: 218.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_605_777",
    x1: 339.004,
    y1: 9.42505,
    x2: 339.004,
    y2: 217.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504355,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99905,
    stopColor: "#777777",
    stopOpacity: 0.257922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_605_777",
    x1: 3.99999,
    y1: 28.4573,
    x2: 3.99999,
    y2: 218.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07BB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927436,
    stopColor: "#07BB8B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_605_777",
    x1: 296.394,
    y1: 152.838,
    x2: 36.7015,
    y2: 150.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0371462,
    stopColor: "#07BBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07BB85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLineGraph);
export default __webpack_public_path__ + "static/media/timeLineGraph.b2ba47bd19188549e2e2d6a1cb226cae.svg";
export { ForwardRef as ReactComponent };